import api from "../config/api";

export const getExpenses = async (data) => {
  const res = await api.post("expenses", data);
  return res.data;
};

export const getExpenseByid = async (_id) => {
  const res = await api.get(`expenses/${_id}`);
  return res.data;
};

export const getExpensesWithSalary = async () => {
  const res = await api.get("expenses/expenseWithSalary");
  return res.data;
};
